<template>
    <div class="add_item">
        <div class="control">
            <div class="prev" :class="{hide: current_step === 0}" @click="prevStep">←</div>
        </div>
        <div class="content">
            <Component
                    :is="step[current_step]"
                    v-bind="{ mode: current_mode }"
                    @nextStep="current_step++"
                    @endStep="addItem()"
            />
        </div>
    </div>
</template>

<script>
    import { mapMutations , mapActions} from 'vuex'

    import SelectItemType from './AddItem/SelectItemType'
    import SelectItemTemp from './AddItem/SelectItemTemp'
    import SelectPosition from './AddItem/SelectPosition'

    export default {
        name: "AddItem",
        components: {SelectItemType, SelectItemTemp, SelectPosition},
        data: () => ({
            current_step: 0,
            current_mode: "add",
            step: [
                'SelectItemType',
                // 'SelectItemTemp',
                //'SelectPosition',
            ]
        }),
        destroyed() {
            this.deleteTempItem();
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["deleteTempItem"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem"]),
            closeModal() { this.setModal(''); },
            prevStep() { if (this.current_step !== 0) this.current_step--; },
            async addItem() {
                await this.commitTempItem();
                this.resetTimer();
                this.setModal('');
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .add_item {
        height: 100%;
        position: relative;
        .control {
            display: flex;
            justify-content: space-between;
            .prev {
                font-size: 20px;
                &.hide{ opacity: 0 }
            }
            .help_close, .prev {
                padding: 0.5rem;
                @extend .clickable;
            }
            .round_btn {
                display: block;
                position: relative;
                width: 30px;
                height: 30px;
                border: 2px solid #333; /* 枠の調整 */
                border-radius: 50%;  /* 丸みの度合い */
                background: #fff; /* ボタンの背景色 */
            }

            .round_btn::before, .round_btn::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 3px; /* 棒の幅（太さ） */
                height: 22px; /* 棒の高さ */
                background: #333; /* バツ印の色 */
            }

            .round_btn::before {
                transform: translate(-50%,-50%) rotate(45deg);
            }

            .round_btn::after {
                transform: translate(-50%,-50%) rotate(-45deg);
            }
        }
        .content {
            height: calc(100% - 3.5rem);
            overflow-y: auto;
        }
    }
</style>
